<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

defineProps<{
  visible: boolean;
  count?: number;
  isSubmitting?: boolean;
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
  confirm: [];
}>();

function close() {
  emit('update:visible', false);
}

function submit() {
  emit('confirm');
}
</script>

<template>
  <Dialog
    :visible="visible"
    modal
    header="Reopen exception"
    class="w-full max-w-xl"
    :style="{ width: '36rem' }"
    :closable="!isSubmitting"
    @update:visible="emit('update:visible', $event)"
  >
    <p class="mb-1 text-sm text-neutral-700">
      <template v-if="(count ?? 1) > 1">
        Reopen {{ count }} exceptions? They will return to the Open list.
      </template>
      <template v-else>
        Reopen this exception? It will return to the Open list.
      </template>
    </p>

    <template #footer>
      <div class="flex flex-nowrap items-center justify-end gap-2">
        <Button
          label="Cancel"
          severity="secondary"
          text
          size="small"
          :disabled="isSubmitting"
          @click="close"
        />
        <Button
          label="Reopen"
          size="small"
          class="whitespace-nowrap"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          @click="submit"
        />
      </div>
    </template>
  </Dialog>
</template>
